import React, { PureComponent } from 'react';
import { Button } from 'react-bootstrap';
import { Guardian } from '@xaamin/guardian';
import { Link, withRouter } from 'react-router-dom';

class SingleComprobanteCloneActions extends PureComponent {

  render() {
    const { data, data: { tipo } } = this.props;
    const { MetodoPago } = data.metadata || {};

    /**
     * Clasificación 11 timbrado xml no soporta clonar o derivados
     */
    let isStampingXml = data.clasificacion !== 11;

    return (
      <>
        { isStampingXml && tipo === 'I' && MetodoPago === 'PUE' && (
          <>
            { Guardian.allows('factura.clonar.nota.credito') && (
              <Button as={ Link }
                variant="secondary"
                to={{
                  pathname: '/app/comprobantes/timbrado',
                  search: `t=E&u=${data.uuid}`
                }}
                className="text-muted mr-2"
              >
                Nota de crédito
              </Button>
            )}

            { Guardian.allows('factura.clonar.nota.debito') && (
              <Button as={ Link }
                variant="secondary"
                to={{
                  pathname: '/app/comprobantes/timbrado',
                  search: `t=I&u=${data.uuid}&r=02`
                }}
                className="text-muted mr-2"
              >
                Nota de débito
              </Button>
            )}
          </>
        )}

        { (isStampingXml && tipo === 'I' && MetodoPago === 'PPD') && (
          <>
            <Button as={ Link }
              variant="secondary"
              to={{
                pathname: '/app/comprobantes/timbrado',
                search: `t=P&u=${data.uuid}`
              }}
              className="text-muted mr-2"
            >
              Agregar pago
            </Button>
          </>
        )}

        { isStampingXml && tipo === 'I' && MetodoPago === 'PPD' && Guardian.allows('administrar_pagos.access') && (
          <>
            <Button as={ Link }
              variant="secondary"
              to={{
                pathname: `/app/comprobantes/${data.uuid}/pagos`
              }}
              className="text-muted mr-2"
            >
              Administrar pagos
            </Button>
          </>
        )}

        { isStampingXml && tipo === 'I' && MetodoPago === 'PPD' && Guardian.allows('factoraje_financiero.access') && (
          <>
            <Button as={ Link }
              variant="secondary"
              to={{
                pathname: `/app/comprobantes/${data.uuid}/factoraje`
              }}
              className="text-muted mr-2"
            >
              Factoraje Financiero
            </Button>
          </>
        )}

        { isStampingXml && Guardian.allows('factura.clonar.documento') && (
          <>
            <Button as={ Link }
              variant="secondary"
              to={{
                pathname: '/app/comprobantes/timbrado',
                search: `t=${data.tipo}&u=${data.uuid}`
              }}
              className="text-muted mr-2"
            >
              Clonar
            </Button>

            <Button as={ Link }
            variant="secondary"
            to={{
              pathname: '/app/comprobantes/timbrado',
              search: `t=${data.tipo}&u=${data.uuid}&r=04`
            }}
            className="text-muted mr-2"
            >
              Sustituir
            </Button>
          </>
        )}
      </>
    )
  }
}

export default withRouter(SingleComprobanteCloneActions);